import { classify } from "../../helpers"

const Flex = ({ children, className = '', onClick, ...props }) => {
	const classes = classify(className, {
		'flex': !props.on,
		[`${props.on}:flex`]: props.on,
		// Alignment
		'items-center': props['items-center'],
		'items-end': props['items-end'],
		'items-stretch': props['items-stretch'],
		// Justify
		'justify-center': props['justify-center'],
		'justify-between': props['justify-between'],
		'justify-end': props['justify-end'],
		// Direction
		'flex-row': props['flex-row'] && !props['flex-row-reverse'],
		'flex-col': props['flex-col'],
		'flex-row-reverse': props['flex-row-reverse'],
		'items-center justify-center': props.center
	})
	return (
		<div className={classes} onClick={(e) => onClick && onClick(e)} >
			{children}
		</div>
	)
}

export default Flex